import styles from './delete-level-dialog.module.scss';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../../requestUtils';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { ILevel } from '../../../../_models/level';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteLevelDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  levelId: string
}

export function DeleteLevelDialog(props: DeleteLevelDialogProps) {
  const { data: level }: { data: ILevel } = useCourseGetRequestHook(`resource/levels/${props.levelId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDeleteLevel = () => {
    setLoading(true);
    makeCourseRequest(`resource/level/delete/${props.levelId}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t('createNewLevel.deletedLevelFromList'), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('createNewLevel.couldNotDeleteLevelFromList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('createNewLevel.areYouSureYouWantToDeleteLevel')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {level?.name}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeleteLevel}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.delete')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteLevelDialog;
